import http from "../http-common";
class RechercheDataService {
  searchAllByName(name) {
    return http.get(`/recherche/rechall?val=${name}`);
  }
  searchDoctorByName(name) {
    return http.get(`/recherche/rechmed?val=${name}`);
  }
  searchStructureByName(name) {
    return http.get(`/recherche/rechstr?val=${name}`);
  }
  searchSpecialitesFromStructure(str,spec) {
    return http.get(`/recherche/rechspec?str=${str}&spec=${spec}`);
  }
  searchSpecialitesFromStructure2(str) {
    return http.get(`/recherche/rechspec2?val=${str}`);
  }
  searchAllSpecialites(val) {
    return http.get(`/recherche/rechallspec?val=${val}`);
  }
  searchLieu(val) {
    return http.get(`/recherche/rechlieu?val=${val}`);
  }
  showDoctor(id) {
    return http.get(`/recherche/medspec?val=${id}`);
  }
  showDoctor2(email) {
    return http.get(`/recherche/medspec2?email=${email}`);
  }
  showStructure(id) {
    return http.get(`/recherche/str?val=${id}`);
  }
  showSpecialite(id) {
    return http.get(`/recherche/spec?val=${id}`);
  }
  showLieu(id) {
    return http.get(`/recherche/lieu?val=${id}`);
  }
  showPlanningFromDoctor(id) {
    return http.get(`/recherche/medplan?val=${id}`);
  }
  showPlanningFromStrSpec(str,spec) {
    return http.get(`/recherche/strspecplan?str=${str}&spec=${spec}`);
  }
  showPlanningFromLieuSpec(lieu,spec) {
    return http.get(`/recherche/lieuspecplan?lieu=${lieu}&spec=${spec}`);
  }
  showPlanningFromPosiSpec(la,lo,spec) {
    return http.get(`/recherche/posispecplan?la=${la}&lo=${lo}&spec=${spec}`);
  }
  showPlageFromPlanning(id) {
    return http.get(`/recherche/plageplan?val=${id}`);
  }
}
export default new RechercheDataService();